module.exports = __webpack_public_path__ + "img/bg-arm.e54e9a0d.jpg";